import React from 'react';

import { cn } from '../../lib/utils';
import type { ConversationAction } from './types';

export interface ConversationActionsProps {
  actions: ConversationAction[];
  onActionClick?: (action: ConversationAction) => void;
  className?: string;
}

export const ConversationActions = ({ actions, onActionClick, className }: ConversationActionsProps) => {
  if (actions.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap gap-2 px-4 py-2', className)}>
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors"
          onClick={() => onActionClick?.(action)}
        >
          {action.label}
          {action.description && <span className="text-muted-foreground">{action.description}</span>}
        </button>
      ))}
    </div>
  );
};
